export interface HotPost {
  id: number;
  rank: number;
  title: string;
  tags: string[];
  heat: string;
  replies: number;
  views: string;
  hot: boolean;
}

export const navLinks: { label: string; key: string }[] = [
  { label: '首页热帖', key: 'hot' },
  { label: '论坛讨论', key: 'forum' },
  { label: '围观现场', key: 'watch' },
  { label: '社区评论', key: 'comments' },
  { label: '站规帮助', key: 'faq' },
];

export const quickStats = [
  { key: 'hot', num: '98', unit: '万', label: '今日热帖曝光', icon: 'ri-fire-fill' },
  { key: 'forum', num: '21', unit: '万', label: '活跃讨论帖', icon: 'ri-chat-3-fill' },
  { key: 'comments', num: '3.6', unit: '亿', label: '累计社区评论', icon: 'ri-message-2-fill' },
  { key: 'watch', num: '12', unit: '万', label: '正在围观人数', icon: 'ri-eye-fill' },
];

export const channels = [
  { label: '圈内八卦', key: 'baf' },
  { label: '网红塌房', key: 'wanghong' },
  { label: '内幕爆料', key: 'leak' },
  { label: '职场瓜', key: 'work' },
  { label: '高校撕X', key: 'school' },
  { label: '素人投稿', key: 'submit' },
  { label: '反转复盘', key: 'reversal' },
  { label: '海量围观', key: 'crowd' },
];

export const hotPosts: HotPost[] = [
  {
    id: 1,
    rank: 1,
    title: '【大瓜】某千万粉主播直播间当场翻车，粉丝集体退订名场面全记录',
    tags: ['网红塌房', '高能'],
    heat: '破千万围观',
    replies: 8843,
    views: '23.6万',
    hot: true,
  },
  {
    id: 2,
    rank: 2,
    title: '反转了！昨天还声讨的素人投稿，今早原帖楼主亲自回应了',
    tags: ['反转复盘', '跟进'],
    heat: '实时置顶',
    replies: 5190,
    views: '18.2万',
    hot: true,
  },
  {
    id: 3,
    rank: 3,
    title: '某大厂年会内幕被连坐曝光，HR 群聊记录流出引全网热议',
    tags: ['职场瓜', '内幕'],
    heat: '火',
    replies: 3762,
    views: '12.9万',
    hot: true,
  },
  {
    id: 4,
    rank: 4,
    title: '教科书级撕X：双胞胎姐妹为工作室归属对簿公堂全程复盘',
    tags: ['圈内八卦', '复盘'],
    heat: '讨论中',
    replies: 2915,
    views: '9.7万',
    hot: false,
  },
  {
    id: 5,
    rank: 5,
    title: '素人投稿：合租室友总偷用我东西，大家帮我看看这波站谁',
    tags: ['素人投稿'],
    heat: '新',
    replies: 2230,
    views: '7.4万',
    hot: false,
  },
  {
    id: 6,
    rank: 6,
    title: '某高校社团爆雷后续，管理员晒出完整时间线求放过',
    tags: ['高校撕X', '跟进'],
    heat: '持续升温',
    replies: 1876,
    views: '5.8万',
    hot: false,
  },
  {
    id: 7,
    rank: 7,
    title: '别急着站队，这五个细节说明事情没那么简单（理性吃瓜）',
    tags: ['围观', '理性'],
    heat: '冷静帖',
    replies: 1641,
    views: '4.6万',
    hot: false,
  },
];

export const watchFeeds = [
  { label: '正在围观', num: '5.2万', title: '全平台吃瓜er汇聚地，实时播报每一波节奏' },
  { label: '今日新增', num: '438', title: '新爆料与投稿持续涌入，刷新即可看最新' },
  { label: '高能预警', num: '97', title: '带爆点的帖子已标红，点进来自带 BGM' },
];

export interface CardItem {
  id: number;
  cover: string;
  tag: string;
  tagColor: string;
  title: string;
  summary: string;
  author: string;
  time: string;
  replies: number;
  hot: number;
}

export const bigCards: CardItem[] = [
  {
    id: 1,
    cover: 'https://readdy.ai/api/search-image?query=Night%20city%20crowd%20with%20glowing%20phone%20screens%20and%20dramatic%20red%20neon%20light%2C%20anonymous%20people%20watching%20social%20media%20feed%2C%20cinematic%20editorial%20photography%2C%20high%20contrast%20warm%20and%20cool%20tones%2C%20dense%20atmosphere&width=900&height=620&seq=cover-a&orientation=landscape',
    tag: '网红塌房',
    tagColor: 'bg-red-600',
    title: '带货一哥翻车背后：从人设到翻车的 48 小时全时间线',
    summary: '楼主逐条复盘从凌晨爆料到深夜回应的每一帧画面，评论区吵翻天，两边都有理有据。',
    author: '吃瓜不嫌事大',
    time: '12 分钟前',
    replies: 8843,
    hot: 9821,
  },
  {
    id: 2,
    cover: 'https://readdy.ai/api/search-image?query=Two%20hands%20shaking%20over%20a%20messy%20contract%20on%20office%20desk%20with%20scattered%20papers%2C%20dramatic%20top%20light%2C%20gossip%20investigation%20mood%2C%20editorial%20reportage%20photography%2C%20muted%20neutral%20colors%20with%20red%20accents&width=900&height=620&seq=cover-b&orientation=landscape',
    tag: '职场瓜',
    tagColor: 'bg-amber-600',
    title: '大厂年会瓜持续发酵，同事站队到底图什么',
    summary: 'HR 与员工各执一词，楼主放出多张截图求公断，理智派和情绪派正在拉锯。',
    author: '班味很重',
    time: '43 分钟前',
    replies: 3762,
    hot: 4120,
  },
  {
    id: 3,
    cover: 'https://readdy.ai/api/search-image?query=Anonymous%20person%20holding%20phone%20in%20dim%20hallway%20with%20suspicious%20backward%20glance%2C%20thriller%20journalism%20vibe%2C%20moody%20lighting%2C%20editorial%20street%20photography%2C%20desaturated%20with%20warm%20highlights&width=900&height=620&seq=cover-c&orientation=landscape',
    tag: '内幕爆料',
    tagColor: 'bg-slate-700',
    title: '深夜投稿：知情人透露的那点事，看到最后人都麻了',
    summary: '楼主自称圈内人放料，细节对得上时间线，但真实性存疑，欢迎评论区打假。',
    author: '一线情报员',
    time: '1 小时前',
    replies: 2915,
    hot: 3308,
  },
  {
    id: 4,
    cover: 'https://readdy.ai/api/search-image?query=Two%20contrasting%20chairs%20facing%20each%20other%20across%20empty%20room%20symbolizing%20opposite%20sides%20in%20heated%20debate%2C%20split%20lighting%20warm%20versus%20cool%2C%20conceptual%20editorial%20composition%2C%20high%20contrast%20minimal&width=900&height=620&seq=cover-d&orientation=landscape',
    tag: '反转复盘',
    tagColor: 'bg-sky-700',
    title: '全网声讨后的惊天反转：当事人终于发声',
    summary: '昨天一边倒，今天剧情急转，楼主带你重新捋一遍谁对谁错，评论区风向已变。',
    author: '反转研究员',
    time: '2 小时前',
    replies: 5190,
    hot: 6002,
  },
];

export interface CommentItem {
  id: number;
  nick: string;
  avatar: string;
  text: string;
  time: string;
  likes: number;
  replies: number;
}

export const commentFeeds: CommentItem[] = [
  {
    id: 1,
    nick: '前排围观',
    avatar: 'xw1',
    text: '蹲一个后续，这瓜看着还有第二集，先占坑。',
    time: '3 分钟前',
    likes: 286,
    replies: 19,
  },
  {
    id: 2,
    nick: '理中客本客',
    avatar: 'xw2',
    text: '别急着冲，等证据链完整再判断，带节奏的看清楚再说话。',
    time: '8 分钟前',
    likes: 541,
    replies: 66,
  },
  {
    id: 3,
    nick: '吃瓜群众甲',
    avatar: 'xw3',
    text: '谁总结一下重点？刚从热搜赶来，前面八百楼看不完。',
    time: '15 分钟前',
    likes: 920,
    replies: 132,
  },
  {
    id: 4,
    nick: '课代表本人',
    avatar: 'xw4',
    text: '给新来的划重点：主楼时间线→图三的回应→评论里的打假，全程 10 分钟看完。',
    time: '22 分钟前',
    likes: 1305,
    replies: 201,
  },
];

export const faqItems = [
  {
    q: '在这里可以发自己的爆料投稿吗？',
    a: '可以。首页有醒目的“发帖投稿”入口，选择对应分区后按模板填写即可。涉及他人隐私、无实锤的内容需谨慎，站务会对过激或不实投稿进行标注与折叠。',
  },
  {
    q: '热帖、讨论、评论、围观之间有什么区别？',
    a: '热帖是当前数据最高的帖子排行；论坛讨论是长文或连载的深度区；社区评论是各帖下方的即时跟评；围观则是实时热度播报与投票互动区，各区块侧重不同，但都围绕同一事件闭环展开。',
  },
  {
    q: '看到明显造谣或不实内容应该怎么办？',
    a: '每个帖子下方都有“举报/标记存疑”入口，站务会根据举报数与可信度做“存疑”标注或下架。理性吃瓜、不传谣是本站底线。',
  },
  {
    q: '围观实时人数和热度是怎么统计的？',
    a: '热度综合浏览、评论、转发与收藏等维度实时计算，页面顶部与各板块头部会随数据更新，仅作当前讨论活跃度的参考。',
  },
  {
    q: '被误伤的当事人可以申诉吗？',
    a: '可以。在对应帖子使用“申诉澄清”入口并附上有效说明，站务优先复核；情况属实会加注“当事人澄清”标识。',
  },
  {
    q: '移动端浏览体验有区别吗？',
    a: '无差异。桌面端与移动端共用同一套数据与内容，仅版式自适应，榜单、卡片流、评论区均可正常围观与参与。',
  },
];

export const hotTopics = [
  { title: '主播翻车名场面', heat: '破千万围观' },
  { title: '大厂年会内幕', heat: '全网热议' },
  { title: '双胞胎撕工作室', heat: '持续升温' },
  { title: '素人投稿求公断', heat: '新晋热帖' },
  { title: '高校社团爆雷', heat: '跟进中' },
  { title: '半夜那个大瓜', heat: '高能预警' },
];

export const footerLinks = [
  { label: '新黑料网论坛' },
  { label: '新黑料网热帖' },
  { label: '新黑料网讨论' },
  { label: '新黑料网评论' },
  { label: '新黑料网社区' },
  { label: '新黑料网围观' },
];